import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsultasLogListComponent } from './consultas-log-list/consultas-log-list.component';

const routes: Routes = [
  {path: '', component: ConsultasLogListComponent},
  {path: 'edit/:id', component: ConsultasLogListComponent},
  {path: 'crear', component: ConsultasLogListComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConsultasLogRoutingModule { }
